// Simple API client. Uses REACT_APP_BACKEND_URL and always credentials:'include' for cookies.
const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;

async function req(path, opts = {}) {
  const res = await fetch(`${API}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(opts.headers || {}) },
    ...opts,
  });
  if (!res.ok) {
    const err = new Error(`HTTP ${res.status}`);
    err.status = res.status;
    try { err.data = await res.json(); } catch (e) { /* noop */ }
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
}

export const api = {
  createRun: (payload) => req("/runs", { method: "POST", body: JSON.stringify(payload) }),
  getRun: (shareId) => req(`/runs/${shareId}`),
  claimRun: (shareId) => req(`/runs/${shareId}/claim`, { method: "POST" }),

  createSession: (session_id) => req("/auth/session", { method: "POST", body: JSON.stringify({ session_id }) }),
  me: () => req("/auth/me"),
  logout: () => req("/auth/logout", { method: "POST" }),

  upgrade: () => req("/user/upgrade", { method: "POST" }),
  downgrade: () => req("/user/downgrade", { method: "POST" }),
  myRuns: () => req("/user/runs"),

  createCheckout: (packageId, originUrl) => req("/payments/checkout", { method: "POST", body: JSON.stringify({ package_id: packageId, origin_url: originUrl }) }),
  paymentStatus: (sessionId) => req(`/payments/status/${sessionId}`),
  genericPaymentStatus: (sessionId) => req(`/payments/generic-status/${sessionId}`),

  paypalCreateOrder: (originUrl) => req("/payments/paypal/create-order", { method: "POST", body: JSON.stringify({ origin_url: originUrl }) }),
  paystackInitialize: (originUrl) => req("/payments/paystack/initialize", { method: "POST", body: JSON.stringify({ origin_url: originUrl }) }),

  requestOtp: (phone_number) => req("/auth/phone/request-otp", { method: "POST", body: JSON.stringify({ phone_number }) }),
  verifyOtp: (phone_number, code) => req("/auth/phone/verify-otp", { method: "POST", body: JSON.stringify({ phone_number, code }) }),

  counselorVerify: (code) => req("/counselor/verify", { method: "POST", body: JSON.stringify({ code }) }),
  counselorAnalytics: (code) => req("/counselor/analytics", { headers: code ? { "X-Counselor-Code": code } : {} }),
};

export { API, BASE };
